import CONSTANTS from '../../features/analyses/Freeform/FreeformAnalysisLayout/AddReportDataLayoutContainer/Constants';
import useWindowSize from './useWindowSize';

function useSmallMobile() {
  const { width } = useWindowSize();
  return width < CONSTANTS.VIEWPORT_WIDTHS.MOBILE;
}

export default useSmallMobile;
